/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getQuickRequestShipmentDetails } from "api/services/quickRequest";
import { useCustomQuery } from "hooks/useCustomQuery";
import { quickRequestQueryKeys } from "./quickRequestQueryKeys";

export const useGetQuickRequestShipmentDetails = (shipmentRef: string, options: UseQueryOptions) =>
  useCustomQuery({
    queryKey: quickRequestQueryKeys.quickRequestShipmentDetails(shipmentRef),
    queryFn: () => getQuickRequestShipmentDetails(shipmentRef).then((res) => res.data),
    ...options,
  });

